import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './styles/tailwind.css';
import './styles/main.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { getConsentStatus, isCookieAllowed } from './utils/cookieUtils';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// Initialize analytics based on cookie consent
const initializeAnalytics = () => {
  const hasConsent = getConsentStatus();
  const analyticsAllowed = isCookieAllowed('analytics');
  
  if (hasConsent && analyticsAllowed) {
    // Initialize analytics here
    console.log('Analytics initialized based on user consent');
  } else {
    console.log('Analytics disabled based on user preferences');
  }
};

// Run on initial load
initializeAnalytics();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
